import "./EventHomepage.css";
import { useNavigate, } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { FaCalendarAlt } from "react-icons/fa";
const offerings = [
    {
        img: "/Images/food.jpeg.jpg",
        title: "Food",
        desc: "Enjoy fresh and delicious meals curated to energize your journey.",
    },
    {
        img: "/Images/travel.jpg",
        title: "Travel",
        desc: "Comfortable and safe travel arrangements for a smooth experience.",
    },
    {
        img: "/Images/accommodation.jpg",
        title: "Accommodation",
        desc: "Stay in well-maintained, clean, and relaxing accommodation spaces.",
    },
];
const aboutSlides = [
    "/Images/image-3.png",
    "/Images/image-2.png",
];
const newsData = [
    {
        image: "/Images/teamlogo1.jpeg.jpg",
        title: "Warriors XI Thrash Titans",
        description: "A dominant performance as Warriors XI secure a massive win in the T20 opener."
    },
    {
        image: "/Images/teamlogo4.jpeg.jpg",
        title: "Match Preview: Royal Kings vs Blasters",
        description: "Both teams prepare for an intense clash in tomorrow’s fixture at Vellore Stadium."
    },
    {
        image: "/Images/teamlogo2.jpeg.jpg",
        title: "Player Spotlight: Arjun Kumar",
        description: "Arjun’s back-to-back fifties make him the star player to watch this season."
    },
];

const fixtures = [
    {
        id: 1,
        teamA: { name: "Warriors XI", logo: "/Images/teamlogo1.jpeg.jpg" },
        teamB: { name: "Titans CC", logo: "/Images/teamlogo2.jpeg.jpg" },
        date: "Dec 14, 2025",
        time: "7:00 PM",
        venue: "Vellore Cricket Stadium"
    },
    {
        id: 2,
        teamA: { name: "Royal Tigers", logo: "/Images/teamlogo3.jpeg.jpg" },
        teamB: { name: "Blue Hawks", logo: "/Images/teamlogo4.jpeg.jpg" },
        date: "Dec 15, 2025",
        time: "6:30 PM",
        venue: "Chennai Turf Arena"
    },
    {
        id: 3,
        teamA: { name: "Thunderbolts", logo: "/Images/teamlogo5.jpeg.jpg" },
        teamB: { name: "Knight Riders", logo: "/Images/teamlogo6.jpeg.jpg" },
        date: "Dec 16, 2025",
        time: "8:00 PM",
        venue: "Bangalore Stadium"
    }
];

const players = [
    { img: "/Images/teamlogo1.jpeg.jpg", name: "Risor sport", },
    { img: "/Images/teamlogo6.jpeg.jpg", name: "Super Kings", },
    { img: "/Images/teamlogo9.jpeg.jpg", name: "Neeraj Rathour", },
    { img: "/Images/teamlogo4.jpeg.jpg", name: "Guru Nanak college", },
    { img: "/Images/teamlogo2.jpeg.jpg", name: "Fearless Fighters", },
    { img: "/Images/teamlogo8.jpeg.jpg", name: "Queen Of Kolihills", },
    { img: "/Images/teamlogo3.jpeg.jpg", name: "AJVJ", },
    { img: "/Images/teamlogo5.jpeg.jpg", name: "Signature", },
    { img: "/Images/teamlogo7.jpeg.jpg", name: "Believe", },
];
const matchFixtures = [
    {
        id: 1,
        category: "previous",
        teamA: { name: "Warriors XI", logo: "/Images/teamlogo1.jpeg.jpg" },
        teamB: { name: "Titans CC", logo: "/Images/teamlogo2.jpeg.jpg" },
        date: "Dec 10, 2025",
        time: "7:00 PM",
        venue: "Vellore Cricket Stadium"
    },
    {
        id: 4,
        category: "current",
        teamA: { name: "Steel Stars", logo: "/Images/teamlogo1.jpeg.jpg" },
        teamB: { name: "Fire Falcons", logo: "/Images/teamlogo2.jpeg.jpg" },
        date: "Dec 13, 2025",
        time: "7:00 PM",
        venue: "Hyderabad Arena"
    },
    {
        id: 5,
        category: "next",
        teamA: { name: "Speed Strikers", logo: "/Images/teamlogo3.jpeg.jpg" },
        teamB: { name: "Iron Wolves", logo: "/Images/teamlogo4.jpeg.jpg" },
        date: "Dec 18, 2025",
        time: "7:30 PM",
        venue: "Delhi Cricket Stadium"
    },
    {
        id: 6,
        category: "next",
        teamA: { name: "Storm Kings", logo: "/Images/teamlogo5.jpeg.jpg" },
        teamB: { name: "Dark Panthers", logo: "/Images/teamlogo6.jpeg.jpg" },
        date: "Dec 20, 2025",
        time: "8:30 PM",
        venue: "Mumbai Dome"
    }
];

export default function EventHomepage() {

    const navigate = useNavigate();

    const handleViewSchedule = () => {
        window.scrollTo(0, 0); // scroll to top
        navigate("/blogs");    // navigate to blogs page
    };
    const [slideIndex, setSlideIndex] = useState(0);

    const totalSlides = matchFixtures.length;

    // Auto slide
    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex(prev => (prev + 1) % totalSlides);
        }, 7000);
        return () => clearInterval(interval);
    }, [totalSlides]);

    const next = () => setSlideIndex((slideIndex + 1) % totalSlides);
    const prev = () => setSlideIndex((slideIndex - 1 + totalSlides) % totalSlides);

    const match = matchFixtures[slideIndex];

    return (
        <div className="event-homepage">
            <section className="heroBanner">
                <div className="heroOverlay"></div>

                <div className="heroContent">
                    <h1 className="heroTitle">AATTUM Men's T-20 Championship</h1>

                    <p className="heroSubtitle">Where Passion Meets Power. Where Talent Becomes Legend.</p>


                    <div className="slide-single4466">
                        <button className="arrow9983 prev9983" onClick={prev}>←</button>

                        <div className="match-content4466">
                            <h2 className="category-title4466">
                                <span className="title-decor4466">{match.category === "previous" ? "Previous Match"
                                    : match.category === "current" ? "Current Match"
                                        : "Upcoming Match"}</span>
                            </h2>
                            <div className="teams-row4466">
                                <div className="team4466">
                                    <img src={match.teamA.logo} alt="" className="team-img4466" />
                                    <p className="team-name4466">{match.teamA.name}</p>
                                </div>

                                <span className="vs4466">VS</span>

                                <div className="team4466">
                                    <img src={match.teamB.logo} alt="" className="team-img4466" />
                                    <p className="team-name4466">{match.teamB.name}</p>
                                </div>
                            </div>

                            <div className="details4466">
                                <p><FaCalendarAlt /> {match.date} • {match.time}</p>
                                <p>{match.venue}</p>
                            </div>

                        </div>

                        <button className="arrow9983 next9983" onClick={next}>→</button>
                    </div>

                    <button
                        className="inspiration-btn112"
                        onClick={() => {
                            navigate("/Atplform");
                            window.scrollTo(0, 0);
                        }}
                    >
                        <span>Register now</span>
                    </button>
                </div>
            </section>

            <section className="about-section">
                <div className="about-container">
                    <div className="about-left">
                        <h2 className="section-title1">About the Championship</h2>
                        <p>
                            The AATTUM Men's T-20 Championship brings you a power-packed cricket experience
                            featuring the finest talents across the region. Expect thrilling finishes, next-gen stars, strategic battles, and unforgettable moments.Experience fierce competition, electrifying atmosphere, and non-stop adrenaline.
This is more than cricket — it’s a battle for greatness.

                        </p>
                        <p>
                        </p>
                    </div>
                    <div className="about-right">
                        <div className="slideshow-container">
                            {aboutSlides.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={"slide-" + index}
                                    className="slideshow-img"
                                    style={{ animationDelay: `${index * 5}s` }}
                                />
                            ))}
                        </div>
                    </div>


                </div>
            </section>

            <section className="upcoming-section">

                <h2 className="section-title">Upcoming Matches</h2>

                <div className="upcoming-table">

                    {fixtures.map(match => (
                        <div key={match.id} className="table-row">

                            {/* TEAM A */}
                            <div className="team">
                                <div className="team-logo-wrapper">
                                    <img src={match.teamA.logo} alt={match.teamA.name} className="team-logo" />
                                </div>
                                <span className="team-name">{match.teamA.name}</span>
                            </div>

                            {/* VS */}
                            <div className="table-vs">VS</div>

                            {/* TEAM B */}
                            <div className="team">
                                <div className="team-logo-wrapper">
                                    <img src={match.teamB.logo} alt={match.teamB.name} className="team-logo" />
                                </div>
                                <span className="team-name">{match.teamB.name}</span>
                            </div>

                            {/* INFO */}
                            <div className="match-details">
                                <p><FaCalendarAlt /> {match.date} • {match.time}</p>
                                <p>{match.venue}</p>
                            </div>

                        </div>
                    ))}

                </div>

                <button className="view-fixtures" onClick={handleViewSchedule}>
                    View Full Schedule
                </button>

            </section>

            {/* ==============================
          5. FEATURED TEAMS
      =============================== */}
            <section className="cricket-players59-section">
                <div className="cricket-players59-header">
                    <img src="/Images/ballimg.png" alt="Ball" className="cricket-players59-ball-icon" />
                    <p className="cricket-players59-note">Stars who turn every match into magic!.</p>
                    <p className="cricket-players59-title">Our Teams</p>
                </div>

                <div className="cricket-players59-container">
                    {players.map((player, index) => (
                        <button key={index} className="cricket-players59-item">
                            <img src={player.img} alt={player.name} className="cricket-players59-photo" />
                            <div className="cricket-players59-info">
                                <h3>{player.name}</h3>
                                <p>{player.role}</p>
                            </div>
                        </button>
                    ))}
                </div>

                <button className="cricket-players59-view-btn">View All Teams</button>
            </section>

            {/* ==============================
          6. RISING STAR PLAYERS
      =============================== */}
            <section className="players-section">
                <h2 className="section-title2">Rising Stars</h2>

                <div className="players-grid">
                    {[1, 2, 3, 4].map((p) => (
                        <div className="player-card" key={p}>
                            <img src={`/Images/player${p}.jpg`} alt="Player" />
                            <h3>Player {p}</h3>
                            <p>All-Rounder • Warriors XI</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="offerings59-section">
                <div className="offerings59-header">
                    <img src="/Images/ballimg.png" alt="Ball" className="offerings59-ball-icon" />
                    <p className="offerings59-subtext">YOUR NEEDS, OUR SERVICE</p>
                    <h2 className="offerings59-title">OUR OFFERINGS</h2>
                </div>

                <div className="offerings59-container">
                    {offerings.map((item, index) => (
                        <div key={index} className="offerings59-card no-click">
                            <div className="offerings59-image-box">
                                <img src={item.img} alt={item.title} />
                            </div>

                            <button className="offerings59-title-btn" disabled>
                                {item.title}
                            </button>

                            <p className="offerings59-desc">{item.desc}</p>

                            <button className="offerings59-click-btn" disabled>
                                →
                            </button>
                        </div>
                    ))}
                </div>
            </section>
            {/* ==============================
          7. NEWS SECTION
      =============================== */}
            <section className="news-section">
                <h2 className="section-title">Latest Updates</h2>

                <div className="news-grid">
                    {newsData.map((item, index) => (
                        <div className="news-card" key={index}>
                            <img src={item.image} alt={item.title} />
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
            </section>


            {/* === SPONSOR SECTION (SEPARATE) === */}
               <section className="sponsor-section">
        <h2>Our Sponsors</h2>
        <p>
          We are proud to be supported by sponsors who share our vision of empowering young talent and promoting sports at every level. Their partnership strengthens our mission, enhances our events, and helps us create greater opportunities for rising athletes across all leagues. Together, we are building a stronger and more impactful sporting future.
        </p>

         <div className="scroll-track11">

              {/* LOGO IMAGES */}
              <img src="/Images/Kairaa1.png" alt="Risor Sports" />
              <img src="/Images/Kairaa2.png" alt="Kairaa Academy" />
              <img src="/Images/Kairaa3.png" alt="Crypto SEP" />
              <img src="/Images/solarnft logo transp.png" alt="Solar NFT" />
               <img src="/Images/Activate Logo.png" alt="Activate" />
              <img src="/Images/Varma Resorts Logo.png" alt="Varma Resorts" />
              <img src="/Images/Kairaa4.png" alt="Pick Now" />
              <img src="/Images/kairaa7.png" alt="Varankal" />
             
            </div>
      </section>

        </div>
    );
}
